import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import PageTemplate from '../../../components/template/PageTemplate';
import RecommendSearchWordSaveContainer from '../../../containers/recommend/searchWord/RecommendSearchWordSaveContainer';
import { recommendSearchWordActions } from '../../../store/modules/recommend/searchWord';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import {
  RECOMMEND_SEARCH_WORD_ITEM_LIST_FILTER_OPTION_MODEL,
  RECOMMEND_SEARCH_WORD_ITEM_LIST_SORT_OPTION_MODEL,
  RECOMMEND_SEARCH_WORD_SAVE_MODEL,
} from '../../../store/modules/recommend/searchWord/models';
import { RECOMMEND_SEARCH_WORD_PAGE_NAME } from '../../../constants/service/app/recommendSearchWordConstants';

class RecommendSearchWordCopy extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   *  초기화
   */
  componentWillUnmount() {
    const { setData } = this.props;

    setData({
      path: ['recommendSearchWordSave'],
      value: RECOMMEND_SEARCH_WORD_SAVE_MODEL,
    });
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendSearchWordId) => {
    const { prepareCopyRecommendSearchWord } = this.props;

    prepareCopyRecommendSearchWord({
      recommendSearchWordId,
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_SEARCH_WORD_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: RECOMMEND_SEARCH_WORD_ITEM_LIST_SORT_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  render() {
    return (
      <PageTemplate pageName={RECOMMEND_SEARCH_WORD_PAGE_NAME.RECOMMEND_SEARCH_WORD_COPY}>
        <RecommendSearchWordSaveContainer typeDisabled={true} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  setData: recommendSearchWordActions.setData,
  prepareCopyRecommendSearchWord: recommendSearchWordActions.prepareCopyRecommendSearchWord,
};

export default connect(null, mapDispatchToProps)(withRouter(RecommendSearchWordCopy));
